import { proxy } from 'valtio';

export const currentPendingChanges = proxy({
  areChangesPending: false,
});
